import { isExcluded } from 'utils/search';

export const getListsFilters = (alert, mapFunc = x => x.id) => ({
  lists: alert.lists?.filter(x => !isExcluded(x))?.map(mapFunc) || [],
  excludeLists: alert.lists?.filter(isExcluded)?.map(mapFunc) || [],
  organisationLists:
    alert.organisationLists?.filter(x => !isExcluded(x))?.map(mapFunc) || [],
  organisationExcludeLists:
    alert.organisationLists?.filter(isExcluded)?.map(mapFunc) || [],
});
